
import { excuseApi } from "../commons/http";

class Package {
  constructor(data = {}) {
    this.name = data.name;
    this.status = data.status;
    this.amount = data.amount;
    this.limit_delivery = data.limit_delivery;
    this.price = data.price;
    this.interval = data.interval;
  }

  mapData(data) {
    this.id = data.id;
    this.name = data.name;
    this.status = data.status;
    this.amount = data.amount;
    this.limit_delivery = data.limit_delivery;
    this.price = data.price;
    this.interval = data.interval;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  async createPackage() {
    const res = await excuseApi({
      path: '/packages',
      method: 'POST',
      body: {
        name: this.name,
        status: this.status,
        amount: this.amount,
        limit_delivery: this.limit_delivery,
        price: this.price,
        interval: this.interval
      }
    });
    if (res.status === 200 || res.status === 201) {
      const packageId = res.data.data.id;
      return { success: true, message: "Thêm gói dịch vụ thành công", id: packageId };
    }
    else {
      return { success: false, message: "Thêm gói dịch vụ thất bại" };
    }
  }

  async getPackageById(id) {
    try {
      console.log('Fetching package with id:', id);
      const res = await excuseApi({
        path: `/packages/${id}`,
        method: 'GET',
      });
      console.log('API response:', res);
      if (res.status === 200 || res.status === 201) {
        const data = res.data.data;
        console.log('Package data:', data);
        return data;
      }
      else {
        console.log('Failed to fetch package data');
        return null;
      }
    }
    catch (error) {
      console.error('Error fetching package:', error);
      throw error;
    }
  }

  async updatePackage(id) {
    try {
      const res = await excuseApi({
        path: `/packages/${id}`,
        method: 'PUT',
        body: {
          name: this.name,
          status: this.status,
          amount: this.amount,
          limit_delivery: this.limit_delivery,
          price: this.price,
          interval: this.interval
        }
      });
      if (res.status === 200 || res.status === 201) {
        return { success: true, message: "Thay đổi thông tin gói dịch vụ thành công" };
      }
      else {
        return null;
      }
    }
    catch (error) {
      throw error;
    }
  }

  async deletePackage(id) {
    try {
      const res = await excuseApi({
        path: `/packages/${id}`,
        method: 'DELETE'
      });
      if (res.status === 200) {
        return { success: true, message: "Xóa gói dịch vụ thành công" };
      }
      else {
        return { success: false, message: "Xóa gói dịch vụ thất bại" };
      }
    }
    catch (error) {
      throw error;
    }
  }
}

export default Package;
